import VueRouter from 'vue-router'
import Layout from '@/layout'
import { newPageView } from '@/api/view'
import { getCurrentDate } from '@/utils/index'

const router = new VueRouter({
  // mode: 'history', // 路由history模式，地址栏不会出现丑丑的 #
  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/home',
      children: [
        {
          path: '/home',
          component: () => import('@/views/home/index'),
          meta: { title: 'Home' }
        }
      ]
    },
    {
      path: '/hlaallele',
      component: Layout,
      children: [
        {
          path: '/hlaallele',
          name: 'hlaallele',
          component: () => import('@/views/hlaallele/index'),
          meta: { title: 'HLA Alleles' }
        },
        // {
        //   path: '/hlaallele/tree',
        //   component: () => import('@/views/hlaallele/tree'),
        //   meta: { title: 'Allele Tree View' }
        // },
        {
          path: '/hlaallele/detail',
          component: () => import('@/views/hlaallele/detail'),
          meta: { title: 'Allele Detail' }
        }
      ]
    },
    {
      path: '/population',
      component: Layout,
      children: [
        {
          path: '/population',
          component: () => import('@/views/population/index'),
          meta: { title: 'Populations' }
        },
        {
          path: '/population/detail',
          component: () => import('@/views/population/detail'),
          meta: { title: 'Population Details' }
        }
      ]
    },
    {
      path: '/tool',
      component: Layout,
      children: [
        {
          path: '/tool/imputation',
          component: () => import('@/views/tool/imputation'),
          meta: { title: 'HLA Imputation' }
        },
        {
          path: '/tool/association',
          component: () => import('@/views/tool/association'),
          meta: { title: 'HLA Association' },
          children: [
            {
              path: '/tool/association/result',
              component: () => import('@/views/tool/association/result'),
              meta: { title: 'HLA Association Results' }
            }
          ]
        }
      ]
    },
    {
      path: '/help',
      component: Layout,
      redirect: '/help/search/allele',
      children: [
        {
          path: '/help',
          component: () => import('@/views/help'),
          meta: { title: 'Help' },
          redirect: '/help/search/allele',
          children: [
            {
              path: '/help/search/allele',
              component: () => import('@/views/help/pages/search/AlleleSearch.vue'),
              meta: { title: 'Help - Search' }
            },
            {
              path: '/help/search/population',
              component: () => import('@/views/help/pages/search/PopSearch.vue'),
              meta: { title: 'Help - Search' }
            },
            {
              path: '/help/data/download',
              component: () => import('@/views/help/pages/data/DataDownload.vue'),
              meta: { title: 'Help - Search' }
            },
            {
              path: '/help/data/sources',
              component: () => import('@/views/help/pages/data/DataSources.vue'),
              meta: { title: 'Help - Data' }
            },
            {
              path: '/help/data/integration',
              component: () => import('@/views/help/pages/data/Integration.vue'),
              meta: { title: 'Help - Data' }
            },
            {
              path: '/help/data/hlatyping',
              component: () => import('@/views/help/pages/data/HlaTyping.vue'),
              meta: { title: 'Help - Data' }
            },
            {
              path: '/help/data/analysis',
              component: () => import('@/views/help/pages/data/Analysis.vue'),
              meta: { title: 'Help - Data' }
            },
            {
              path: '/help/tool/datasecurity',
              component: () => import('@/views/help/pages/tools/DataSecurity.vue'),
              meta: { title: 'Help - Analysis' }
            },
            {
              path: '/help/tool/imputation',
              component: () => import('@/views/help/pages/tools/Imputation.vue'),
              meta: { title: 'Help - Analysis' }
            },
            {
              path: '/help/tool/comparison',
              component: () => import('@/views/help/pages/tools/Comparison.vue'),
              meta: { title: 'Help - Analysis' }
            },
            {
              path: '/help/others/changelog',
              component: () => import('@/views/help/pages/others/ChangeLog.vue'),
              meta: { title: 'Help - Others' }
            }
          ]
        }

      ]
    },
    {
      path: '/statistics',
      component: Layout,
      children: [
        {
          path: '/statistics',
          component: () => import('@/views/statistics'),
          meta: { title: 'Statistics' }
        }
      ]
    },
    {
      path: '/about',
      component: Layout,
      children: [
        {
          path: '/about',
          component: () => import('@/views/about'),
          meta: { title: 'About' }
        }
      ]
    }
  ]
})

// 全局后置路由守卫 用于更改页签标题
router.afterEach((to) => {
  const affix = 'PGG.MHC'
  const title = to.meta.title
  document.title = title ? `${title} - ${affix}` : affix
  const query = {
    viewDate: getCurrentDate(),
    ip: localStorage.getItem('userIP'),
    page: title
  }
  console.log('!!!', getCurrentDate())
  sendViewDate(query)
})

const sendViewDate = async(query) => {
  await newPageView(query)
}

export default router
